import { render, staticRenderFns } from "./Premium.vue?vue&type=template&id=1c3d3084&"
import script from "./Premium.vue?vue&type=script&lang=js&"
export * from "./Premium.vue?vue&type=script&lang=js&"
import style0 from "./Premium.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Premium.vue"
export default component.exports